import { UiTypography } from '@/components/ui/Typography';
import { PHEON_SUPPORT_EMAIL } from '@/constants';

export function DefaultDescription() {
  return (
    <>
      <UiTypography variant="body-small" color="neutral-black" align="center">
        No commitment. Cancel any time.
      </UiTypography>
      <UiTypography
        variant="body-small"
        color="neutral-black"
        align="center"
        className="local-description"
      >
        By clicking GET PREMIUM you agree that the plan you selected will
        automatically renew unless it's cancelled. To manage your subscription,
        please contact us at{' '}
        <a href={`mailto:${PHEON_SUPPORT_EMAIL}`} target="_blank">
          {PHEON_SUPPORT_EMAIL}
        </a>
      </UiTypography>
    </>
  );
}
